export default __webpack_public_path__ + "static/media/trustError.5de9b035.svg";